import React from 'react';

const Footer = () => {
    return(
        <footer>
            <div className='footer-container'>
                <div className= "sec aboutus" style={{ "paddingRight": "50px"}}>
                    <h4>About Us</h4>
                    <ul style={{"color": "#999", textAlign:"justify"}}>
                        <li> At GharBar Hotel we strive to be the first choice in the mind of guests, owners and talent.
                        In our journey to achieve this, we practice strong beliefs and actions that respect the
                        diversity of people, the community, ethics and the planet.</li>
                    </ul>
                    <ul className="sci">
                        <li><a href="!#"><i style={{color:"#ffc107"}} className="fa-brands fa-facebook" aria-hidden="true"></i> </a></li>
                        <li><a href="!#"><i style={{color:"#ffc107"}} className="fa-brands fa-twitter" aria-hidden="true"></i> </a></li>
                        <li><a href="!#"><i style={{color:"#ffc107"}} className="fa-brands fa-instagram" aria-hidden="true"></i> </a></li>
                        <li><a href="!#"><i style={{color:"#ffc107"}} className="fa-brands fa-youtube" aria-hidden="true"></i> </a></li>
                    </ul>
                </div>
                <div className= "sec quickLinks">
                    <h4>Developed By</h4>
                    <ul style={{ "color": "#dcb103" }}>
                        <li> <i className=" fa-brands fa-github" /> &nbsp; <a href="https://www.github.com/rksharma007" target="_blank" rel="noopener noreferrer" >R K Sharma</a></li>
                    </ul>
                </div>
                <div className= "sec contact">
                    <h4>Contact Us</h4>
                    <ul className="info"> 
                        <li>
                            <span><i className="fa fa-location-dot"></i></span>
                            <span>A-11, Clock Tower, New Delhi-59</span>
                        </li>
                        <li>
                            <span><i className="fa fa-phone"></i></span>
                            <span>+91 9876543587</span>
                        </li>
                        <li>
                            <span><i className="fa fa-envelope"></i></span>
                            <span>info.gharbar@gmail.com</span>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
